import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getDefaultClasses } from '../../../../utils/style-utils'
import { ContentStateProperty, ScreenProperty } from '../../../../@types/types'
import { useAppSelector } from '../../../../app/hooks'
import { InitState } from '../../../../redux/reducers/root/initialState'

interface AddAndRemoveExtraFieldsButtonProps {
  className?: string
  propertyToWatch: ContentStateProperty
  children: React.ReactNode
  onChange: (property: string, value: string | boolean | undefined) => void
  doReset: (clearingUpOf: ScreenProperty[]) => void
}

const AdOtherFieldBehindTextButton = ({
  children,
  propertyToWatch,
  onChange,
  doReset,
  className = getDefaultClasses('left'),
}: AddAndRemoveExtraFieldsButtonProps) => {
  const { t } = useTranslation()

  const { adOther } = useAppSelector((state: InitState) => state.insertionFeature.insertionData)

  const [isAddFieldTextShown, setIsAddFieldTextShown] = useState(true)
  useEffect(() => (adOther ? setIsAddFieldTextShown(false) : setIsAddFieldTextShown(true)), [adOther])

  const isFieldFilledWithValue = !isAddFieldTextShown || adOther
  const handleClick = () => {
    callReset()
    setIsAddFieldTextShown(!isAddFieldTextShown)
  }

  const callReset = () => {
    const resetAdOther: ScreenProperty = {
      screen: 'description',
      property: propertyToWatch,
    }
    onChange(propertyToWatch, undefined)
    doReset([resetAdOther])
  }

  return (
    <div>
      {isFieldFilledWithValue && children}
      <button
        id='add-extra-field-button'
        className={`link-text background-none border-none padding-horizontal-none ${className}`}
        onClick={handleClick}
      >
        {!isFieldFilledWithValue && <span>{t('wizard.screen.description.addExtraField', 'Add extra field')}</span>}
        {isFieldFilledWithValue && <span>{t('wizard.screen.description.removeExtraField', 'Remove extra field')}</span>}
      </button>
    </div>
  )
}

export default AdOtherFieldBehindTextButton
